import React, { useState, useEffect } from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import FormControl from "@material-ui/core/FormControl";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { makeStyles } from "@material-ui/core";
import ButtonWithSpinner from "../ButtonWithSpinner";
import TicketsUserTransferirSelect from "../TicketsUserTransferirSelect";
import { BotaoCancelar, BotaoConfirmar } from "../BotoesModal";

const useStyles = makeStyles((theme) => ({
	maxWidth: {
		width: '100%',
	},
}));

const TicketTransferirModal = ({ modalOpen, onClose, user }) => {
	const [selectedUser, setSelectedUser] = useState("");
	const [loading, setLoading] = useState(false);

	const classes = useStyles();

	useEffect(() => {
		setLoading(false);
		setSelectedUser("");
	}, [modalOpen]);

	const handleClose = async () => {
		setLoading(true);
		await onClose(selectedUser);
		setLoading(false);
	};

	const handleCancel = () => {
		setSelectedUser("");
		onClose();
	};

	return (
		<Dialog open={modalOpen} onClose={handleClose} fullWidth maxWidth="xs">
			<DialogTitle id="form-dialog-title">
				Transferir lead para outro atendente
			</DialogTitle>
			<DialogContent dividers>
				<FormControl variant="outlined" className={classes.maxWidth}>
					<TicketsUserTransferirSelect
						filialId={user.filial_icode}
						onChange={(value) => setSelectedUser(value)}
					/>
				</FormControl>
			</DialogContent>
			<DialogActions>
				<BotaoCancelar onClick={() => handleCancel()} disabled={loading}>
					Cancelar
				</BotaoCancelar>
				<BotaoConfirmar type="button" onClick={() => handleClose()} loading={loading}>
					Transferir
				</BotaoConfirmar>
			</DialogActions>
		</Dialog>
	);
};

export default TicketTransferirModal;
